import { createRouter, createWebHashHistory } from 'vue-router'
import { useAuthStore } from '@/stores/auth'

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/index.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/',
    name: 'Layout',
    component: () => import('@/views/layout/index.vue'),
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'Home',
        component: () => import('@/views/home/index.vue'),
        meta: { title: '首页' }
      },
      // 充值管理
      {
        path: 'recharge-channel',
        name: 'RechargeChannel',
        component: () => import('@/views/recharge-channel/index.vue'),
        meta: { title: '充值通道管理' }
      },
      {
        path: 'recharge-order',
        name: 'RechargeOrder',
        component: () => import('@/views/recharge-order/index.vue'),
        meta: { title: '充值订单管理' }
      },
      // 钱包管理
      {
        path: 'wallet-address',
        name: 'WalletAddress',
        component: () => import('@/views/wallet-address/index.vue'),
        meta: { title: '收款钱包地址' }
      },
      {
        path: 'user-pay-account',
        name: 'UserPayAccount',
        component: () => import('@/views/user-pay-account/index.vue'),
        meta: { title: '用户支付账户' }
      },
      // 申请管理
      {
        path: 'withdrawal-request',
        name: 'WithdrawalRequest',
        component: () => import('@/views/withdrawal-request/index.vue'),
        meta: { title: '提现申请管理' }
      },
      {
        path: 'recharge-request',
        name: 'RechargeRequest',
        component: () => import('@/views/recharge-request/index.vue'),
        meta: { title: 'USDT充值申请' }
      },
      // 提现手续费配置
      {
        path: 'withdraw-fee-config',
        name: 'WithdrawFeeConfig',
        component: () => import('@/views/withdraw-fee-config/index.vue'),
        meta: { title: '提现手续费配置' }
      },
      // 提现配置
      {
        path: 'withdraw-config',
        name: 'WithdrawConfig',
        component: () => import('@/views/withdraw-config/index.vue'),
        meta: { title: '提现配置' }
      },
      // USDT汇率配置
      {
        path: 'usdt-rate',
        name: 'UsdtRateConfig',
        component: () => import('@/views/usdt-rate/index.vue'),
        meta: { title: 'USDT汇率配置', icon: 'Money' }
      },
      {
        path: 'user-default-profile',
        name: 'UserDefaultProfile',
        component: () => import('@/views/user-default-profile/index.vue'),
        meta: { title: '用户默认资料' }
      },
      // 用户管理
      {
        path: 'player/list',
        name: 'PlayerList',
        component: () => import('@/views/player/index.vue'),
        meta: { title: '用户列表' }
      },
      {
        path: 'player/point-log',
        name: 'PointLog',
        component: () => import('@/views/player/point-log.vue'),
        meta: { title: '积分流水' }
      },
      {
        path: 'official-group',
        name: 'OfficialGroup',
        component: () => import('@/views/official-group/index.vue'),
        meta: { title: '官方默认群' }
      },
      // 财务报表
      {
        path: 'finance/recharge',
        name: 'FinanceRecharge',
        component: () => import('@/views/finance/recharge.vue'),
        meta: { title: '充值流水' }
      },
      {
        path: 'finance/withdraw',
        name: 'FinanceWithdraw',
        component: () => import('@/views/finance/withdraw.vue'),
        meta: { title: '提现流水' }
      },
      {
        path: 'finance/transfer',
        name: 'FinanceTransfer',
        component: () => import('@/views/finance/transfer.vue'),
        meta: { title: '转账流水' }
      },
      // 红包管理
      {
        path: 'redpacket/flow',
        name: 'RedpacketFlow',
        component: () => import('@/views/redpacket/flow.vue'),
        meta: { title: '红包发包流水' }
      },
      // 运营统计
      {
        path: 'stats/overview',
        name: 'StatsOverview',
        component: () => import('@/views/stats/overview.vue'),
        meta: { title: '统计概览' }
      },
      {
        path: 'stats/dau',
        name: 'StatsDau',
        component: () => import('@/views/stats/dau.vue'),
        meta: { title: '日活统计' }
      },
      {
        path: 'stats/new-users',
        name: 'StatsNewUsers',
        component: () => import('@/views/stats/new-users.vue'),
        meta: { title: '新增用户统计' }
      },
      // 客服管理
      {
        path: 'customer-service',
        name: 'CustomerService',
        component: () => import('@/views/customer-service/index.vue'),
        meta: { title: '客服配置', icon: 'Service' }
      },
      // 通知公告
      {
        path: 'platform-notice',
        name: 'PlatformNotice',
        component: () => import('@/views/platform-notice/index.vue'),
        meta: { title: '通知公告' }
      },
      // 系统管理
      {
        path: 'sys/user',
        name: 'SysUser',
        component: () => import('@/views/sys/user/index.vue'),
        meta: { title: '用户管理' }
      },
      {
        path: 'sys/role',
        name: 'SysRole',
        component: () => import('@/views/sys/role/index.vue'),
        meta: { title: '角色管理' }
      },
      {
        path: 'sys/menu',
        name: 'SysMenu',
        component: () => import('@/views/sys/menu/index.vue'),
        meta: { title: '菜单管理' }
      }
    ]
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  const authStore = useAuthStore()
  
  if (to.meta.requiresAuth && !authStore.isAuthenticated) {
    next('/login')
  } else if (to.path === '/login' && authStore.isAuthenticated) {
    next('/')
  } else {
    next()
  }
})

export default router
